export default __webpack_public_path__ + "static/media/banefits-img-2.0a12c7be.png";